<script setup lang="ts">
// PROPS
const { salesContact } = defineProps({
    salesContact: { type: Object as PropType<SalesContact>, required: true },
});

// COMPOSABLES
const { trackSalesContactWhatsappButton } = useTracking();
</script>

<template>
    <UButton
        icon="fl:whatsapp"
        color="success"
        size="xl"
        :to="salesContact.whatsAppLink"
        target="_blank"
        square
        @click="trackSalesContactWhatsappButton"
    />
</template>
